module.exports = __webpack_public_path__ + "img/default_avatar.57d33e9d.png";